export const LEGAL_EN = {
    // grievances — Art. 72 as amended
    "value.statute_key.grievances.court_objection_days": "Days to take a refused or undecided objection to the labour court (official holidays excluded)",
    "value.statute_key.payroll.month_days": "Days in a month for a day's wage",
    "value.reading_source.default": "Adopted default",
    "value.reading_source.override": "Decided here",
    "value.counsel_review.pending_counsel": "Adopted, pending the lawyer's review",
    "value.legal_reading.scheduling.overtime_past_ceiling": "Overtime past the year's ceiling",
    "value.legal_reading.offboarding.notice_counting": "Counting the notice days",
    "value.legal_reading.discipline.demotion_listed": "The approved regulation lists demotion",
    "value.legal_reading.leave.settlement_rounding": "Leave left, as paid at the end",
    "value.legal_reading.leave.iddah_calendar": "Counting the iddah",
    "value.legal_reading_value.flag_with_consent": "Flagged where a written consent is recorded",
    "value.legal_reading_value.refuse": "Refused even with a consent",
    "value.legal_reading_value.inclusive": "Both ends counted",
    "value.legal_reading_value.exclusive": "One end counted",
    "value.legal_reading_value.yes": "Yes",
    "value.legal_reading_value.no": "No",
    "value.legal_reading_value.true": "Yes",
    "value.legal_reading_value.false": "No",
    "value.legal_reading_value.fraction_days": "To two decimal places",
    "value.legal_reading_value.whole_days_half_up": "Whole days, half up",
    "value.legal_reading_value.gregorian": "Gregorian months",
    "value.legal_reading_value.hijri": "Hijri months (Umm al-Qura)",
    "value.legal_reading_basis.scheduling.overtime_past_ceiling": "Implementing Regulation Art. 22: the ceiling may be exceeded with the worker's written consent.",
    "value.legal_reading_basis.offboarding.notice_counting": "Art. 75: \"not less than\" the days before the end — counting both ends is the generous reading.",
    "value.legal_reading_basis.discipline.demotion_listed": "Arts. 66/67: demotion is not in the law's list; only where the ministry-approved regulation names it.",
    "value.legal_reading_basis.leave.settlement_rounding": "Art. 111: the leave left is paid at the end — two decimals kept, the cash rounded half up once.",
    "value.legal_reading_basis.leave.iddah_calendar": "Arts. 160 and 10: four months and ten days — Gregorian gives a few days more, with Gregorian counting stated in the regulation and the contract.",
    "change.field.legal_reading.key": "Reading",
    "change.field.legal_reading.value": "Value",
    "change.field.legal_reading.note": "Why",
    "change.field.legal_reading.set_by": "Decided by",
    "change.field.legal_reading.set_at": "Decided at",
    "change.field.legal_reading.reverted_by": "Put back by",
    "change.field.legal_reading.reverted_at": "Put back at",
    "legal_reading.refusal.value": "Not a value this reading takes.",
    "legal_reading.refusal.unknown": "Not a legal reading of this unit.",
    "legal_reading.refusal.already_default": "This reading already follows the adopted default.",
    "gov_sa.gosi.readings.screen.title": "Legal readings",
    "gov_sa.gosi.readings.col.key": "Reading",
    "gov_sa.gosi.readings.col.value": "In use",
    "gov_sa.gosi.readings.col.default_value": "Adopted default",
    "gov_sa.gosi.readings.col.source": "From",
    "gov_sa.gosi.readings.col.counsel_review": "Counsel's review",
    "gov_sa.gosi.readings.col.basis": "What the default rests on",
    "gov_sa.gosi.readings.col.note": "Why decided otherwise",
    "gov_sa.gosi.readings.col.set_on": "Decided on",
    "gov_sa.gosi.readings.stat.overridden": "Decided otherwise here",
    "gov_sa.gosi.readings.stat.pending": "Waiting for the lawyer's review",
    "gov_sa.gosi.readings.action.revert_all": "Put every reading back to the adopted default",
    "gov_sa.gosi.readings.reveal.reverted": "Readings put back",
    "gov_sa.gosi.readings.reveal.note": "Every reading now follows the owner's adopted default. The decisions put back stay in the change record.",
    "gov_sa.gosi.readings.action.set": "Decide",
    "gov_sa.gosi.readings.action.revert": "Put back to the default",
    "gov_sa.gosi.readings.field.value": "Value",
    "gov_sa.gosi.readings.field.note": "Why, and on what",
    "gov_sa.gosi.readings.field.note.help": "The regulation, the contract clause or the opinion this decision rests on.",
    "gov_sa.gosi.readings.screen.lede": "Where the law allows two readings, the owner's adopted default applies until the establishment decides otherwise; all await the lawyer.",
    "nav.gosi.readings": "GOSI legal readings",
    "gov_sa.gosi.readings.field.value.gosi_new_scheme_step_day.help": "Month and day, MM-DD, the 1st to the 28th.",
    "value.legal_reading.gosi.new_scheme_step_day": "The day of the new scheme's later yearly steps",
    "value.legal_reading.gosi.citizen_wage_floor": "Citizens' contributory wage floor (SAR)",
    "value.legal_reading_basis.gosi.new_scheme_step_day": "GOSI applied the first step from 1 July 2025; the later steps on the same day of each year.",
    "value.legal_reading_basis.gosi.citizen_wage_floor": "At least SAR 1,500 for annuities and SANED (secondary sources); zero ships no floor.",
    "gov_sa.gosi.rates.col.counsel_review": "Counsel's review",
    "gov_sa.gosi.rates.col.pending_counsel": "Adopted, pending the lawyer's review",
    "gov_sa.gosi.rates.stat.pending_counsel": "Adopted, pending the lawyer's review",
    "gov_sa.gosi.rates.action.adopt": "Adopt the most likely reading",
    "gov_sa.gosi.rates.reveal.proposed": "Rows proposed",
    "gov_sa.gosi.rates.reveal.withdrawn": "Unconfirmed rows it replaced",
    "gov_sa.gosi.rates.reveal.skipped": "Rows skipped",
    "gov_sa.gosi.rates.reveal.note": "The adopted rows wait for somebody other than you to confirm them. A confirmed row is never touched; an unconfirmed one on the same day is withdrawn, not deleted.",
    "gov_sa.gosi.settings.restore": "Restore the adopted defaults",
    "gov_sa.gosi.settings.restored": "The deadlines follow the adopted defaults again.",
    "screen.privacy.terms.column.counsel_review": "Counsel's review",
    "screen.privacy.terms.column.pending_counsel": "Adopted, pending the lawyer's review",
    "screen.privacy.terms.stat.pending_counsel": "Adopted, pending the lawyer's review",
    "screen.privacy.terms.action.adopt": "Adopt the most likely reading",
    "screen.privacy.terms.reveal.proposed": "Periods proposed",
    "screen.privacy.terms.reveal.skipped": "Periods already adopted",
    "screen.privacy.terms.reveal.note": "Each adopted period starts today — tomorrow where a row already starts today — and waits for somebody other than you to confirm it.",
    "privacy.refusal.own_term": "Whoever proposed a period does not confirm it; somebody else checks it against the law.",
};
export const LEGAL_AR = {
    "value.statute_key.grievances.court_objection_days": "أيام اللجوء إلى المحكمة العمالية بعد رفض التظلّم أو عدم البتّ فيه (دون العطل الرسمية)",
    "value.statute_key.payroll.month_days": "أيام الشهر في حساب أجر اليوم",
    "value.reading_source.default": "الافتراضي المعتمد",
    "value.reading_source.override": "مقرّر هنا",
    "value.counsel_review.pending_counsel": "معتمد بانتظار مراجعة المحامي",
    "value.legal_reading.scheduling.overtime_past_ceiling": "العمل الإضافي فوق السقف السنوي",
    "value.legal_reading.offboarding.notice_counting": "عدّ أيام الإنذار",
    "value.legal_reading.discipline.demotion_listed": "لائحة العمل المعتمدة تنصّ على خفض الدرجة",
    "value.legal_reading.leave.settlement_rounding": "رصيد الإجازة عند التسوية",
    "value.legal_reading.leave.iddah_calendar": "حساب العدّة",
    "value.legal_reading_value.flag_with_consent": "تنبيه حيث سُجّلت موافقة مكتوبة",
    "value.legal_reading_value.refuse": "رفض ولو بموافقة",
    "value.legal_reading_value.inclusive": "شاملاً الطرفين",
    "value.legal_reading_value.exclusive": "طرف واحد",
    "value.legal_reading_value.yes": "نعم",
    "value.legal_reading_value.no": "لا",
    "value.legal_reading_value.true": "نعم",
    "value.legal_reading_value.false": "لا",
    "value.legal_reading_value.fraction_days": "بمنزلتين عشريتين",
    "value.legal_reading_value.whole_days_half_up": "أيام كاملة، والنصف لأعلى",
    "value.legal_reading_value.gregorian": "بالأشهر الميلادية",
    "value.legal_reading_value.hijri": "بالأشهر الهجرية (أم القرى)",
    "value.legal_reading_basis.scheduling.overtime_past_ceiling": "اللائحة التنفيذية م. 22: يجوز تجاوز السقف بموافقة العامل الكتابية.",
    "value.legal_reading_basis.offboarding.notice_counting": "م. 75: «بما لا يقل عن» الأيام قبل الإنهاء — عدّ الطرفين هو الأرفق بالعامل.",
    "value.legal_reading_basis.discipline.demotion_listed": "م. 66/67: خفض الدرجة ليس من جزاءات النظام؛ لا يوقَّع إلا إن نصّت عليه اللائحة المعتمدة من الوزارة.",
    "value.legal_reading_basis.leave.settlement_rounding": "م. 111: يُدفع رصيد الإجازة عند انتهاء الخدمة — يُحفظ بمنزلتين، ويُقرَّب المبلغ لأعلى عند النصف مرة واحدة.",
    "value.legal_reading_basis.leave.iddah_calendar": "م. 160 وم. 10: أربعة أشهر وعشرة أيام — الميلادي يزيد أياماً قليلة، مع النصّ على العدّ الميلادي في اللائحة والعقد.",
    "change.field.legal_reading.key": "القراءة",
    "change.field.legal_reading.value": "القيمة",
    "change.field.legal_reading.note": "السبب",
    "change.field.legal_reading.set_by": "قرّرها",
    "change.field.legal_reading.set_at": "وقت القرار",
    "change.field.legal_reading.reverted_by": "أرجعها",
    "change.field.legal_reading.reverted_at": "وقت الإرجاع",
    "legal_reading.refusal.value": "ليست قيمة تقبلها هذه القراءة.",
    "legal_reading.refusal.unknown": "ليست قراءة نظامية لهذه الوحدة.",
    "legal_reading.refusal.already_default": "هذه القراءة تتبع القيمة الافتراضية المعتمدة أصلاً.",
    "gov_sa.gosi.readings.screen.title": "القراءات النظامية المرجّحة",
    "gov_sa.gosi.readings.col.key": "القراءة",
    "gov_sa.gosi.readings.col.value": "المعمول به",
    "gov_sa.gosi.readings.col.default_value": "القيمة الافتراضية المعتمدة",
    "gov_sa.gosi.readings.col.source": "المصدر",
    "gov_sa.gosi.readings.col.counsel_review": "مراجعة المحامي",
    "gov_sa.gosi.readings.col.basis": "أساس القيمة الافتراضية",
    "gov_sa.gosi.readings.col.note": "سبب القرار المخالف",
    "gov_sa.gosi.readings.col.set_on": "تاريخ القرار",
    "gov_sa.gosi.readings.stat.overridden": "مقرّرة هنا بخلاف الافتراضي",
    "gov_sa.gosi.readings.stat.pending": "بانتظار مراجعة المحامي",
    "gov_sa.gosi.readings.action.revert_all": "إرجاع الكل إلى القيم الافتراضية",
    "gov_sa.gosi.readings.reveal.reverted": "القراءات المُرجَعة",
    "gov_sa.gosi.readings.reveal.note": "كل القراءات تتبع الآن القيمة الافتراضية التي اعتمدها المالك. والقرارات المُرجَعة باقية في سجل التغيير.",
    "gov_sa.gosi.readings.action.set": "تقرير",
    "gov_sa.gosi.readings.action.revert": "إرجاع إلى الافتراضي",
    "gov_sa.gosi.readings.field.value": "القيمة",
    "gov_sa.gosi.readings.field.note": "السبب والمستند",
    "gov_sa.gosi.readings.field.note.help": "اللائحة أو بند العقد أو الرأي الذي يستند إليه هذا القرار.",
    "gov_sa.gosi.readings.screen.lede": "حيث يحتمل النظام قراءتين تسري القيمة المعتمدة حتى تقرّر المنشأة غيرها؛ وكلها بانتظار المحامي.",
    "nav.gosi.readings": "القراءات النظامية للتأمينات",
    "gov_sa.gosi.readings.field.value.gosi_new_scheme_step_day.help": "الشهر واليوم بالصيغة MM-DD، من اليوم 1 إلى 28.",
    "value.legal_reading.gosi.new_scheme_step_day": "يوم الخطوات السنوية اللاحقة للنظام الجديد",
    "value.legal_reading.gosi.citizen_wage_floor": "الحد الأدنى لأجر الاشتراك للمواطنين (ريال)",
    "value.legal_reading_basis.gosi.new_scheme_step_day": "طبّقت التأمينات الخطوة الأولى من 1 يوليو 2025؛ والخطوات اللاحقة في اليوم نفسه من كل سنة.",
    "value.legal_reading_basis.gosi.citizen_wage_floor": "1,500 ريال على الأقل للمعاشات وساند (مصادر ثانوية)؛ والصفر يعني بلا حد أدنى.",
    "gov_sa.gosi.rates.col.counsel_review": "مراجعة المحامي",
    "gov_sa.gosi.rates.col.pending_counsel": "معتمد بانتظار مراجعة المحامي",
    "gov_sa.gosi.rates.stat.pending_counsel": "معتمد بانتظار مراجعة المحامي",
    "gov_sa.gosi.rates.action.adopt": "اعتماد القراءة المرجّحة",
    "gov_sa.gosi.rates.reveal.proposed": "الصفوف المقترحة",
    "gov_sa.gosi.rates.reveal.withdrawn": "صفوف غير مؤكّدة حلّ محلّها",
    "gov_sa.gosi.rates.reveal.skipped": "الصفوف المتخطّاة",
    "gov_sa.gosi.rates.reveal.note": "الصفوف المعتمدة بانتظار تأكيد شخص غيرك. لا يُمسّ صف مؤكَّد؛ ويُسحب غير المؤكَّد في اليوم نفسه ولا يُحذف.",
    "gov_sa.gosi.settings.restore": "إرجاع القيم الافتراضية المعتمدة",
    "gov_sa.gosi.settings.restored": "عادت المواعيد إلى القيم الافتراضية المعتمدة.",
    "screen.privacy.terms.column.counsel_review": "مراجعة المحامي",
    "screen.privacy.terms.column.pending_counsel": "معتمد بانتظار مراجعة المحامي",
    "screen.privacy.terms.stat.pending_counsel": "معتمد بانتظار مراجعة المحامي",
    "screen.privacy.terms.action.adopt": "اعتماد القراءة المرجّحة",
    "screen.privacy.terms.reveal.proposed": "المدد المقترحة",
    "screen.privacy.terms.reveal.skipped": "مدد اعتُمدت من قبل",
    "screen.privacy.terms.reveal.note": "تسري كل مدة معتمدة من اليوم — أو من الغد إن كان صف يبدأ اليوم — وتنتظر تأكيد شخص غيرك.",
    "privacy.refusal.own_term": "من اقترح المدة لا يؤكّدها؛ يراجعها شخص آخر على النظام.",
};
//# sourceMappingURL=i18n-legal.js.map